import { Button } from '@pets-ui/Button/Button'
import { Checkbox, type CheckboxProps } from '@pets-ui/Checkbox/Checkbox'
import { Footer } from '@pets-ui/Footer/Footer'
import { FooterStack } from '@pets-ui/FooterStack/FooterStack'
import { CartOutlined } from '@pets-ui/icons'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  footerStack: {
    padding: 0,
  },
  cartButton: {
    backgroundColor: {
      'default': colors.black,
      ':disabled': colors.grey300,
    },
    whiteSpace: 'nowrap',
    marginLeft: '16px',
  },
  checkbox: {
    whiteSpace: 'nowrap',
  },
})

export interface AiRecommendationFooterProps {
  allChecked: boolean
  checkAllIndeterminate?: boolean
  onCheckAllChange: CheckboxProps['onChange']
  onSubmit: () => void
  submitDisabled?: boolean
  submitLabel?: string
  submitLoading?: boolean
}

export const AiRecommendationFooter = ({ allChecked, checkAllIndeterminate, onCheckAllChange, onSubmit, submitDisabled, submitLabel = '加入採購', submitLoading }: AiRecommendationFooterProps) => {
  const isMobile = useResponsive('mobile')

  return (
    <FooterStack enableContainer rootStyle={styles.footerStack}>
      <Footer ContainerProps={{ justifyContent: 'space-between' }}>
        <Checkbox
          color="blue"
          checked={allChecked}
          indeterminate={checkAllIndeterminate}
          onChange={onCheckAllChange}
          label="全選"
          rootStyle={styles.checkbox}
        />
        <Button
          rootStyle={styles.cartButton}
          startIcon={<CartOutlined />}
          variant="filled"
          minWidth={isMobile ? undefined : 140}
          fullWidth={isMobile}
          onClick={onSubmit}
          disabled={submitDisabled}
          loading={submitLoading}
        >
          {submitLabel}
        </Button>
      </Footer>
    </FooterStack>
  )
}
